var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.728942 8.46985C0.588491 8.61047 0.509603 8.8011 0.509603 8.99985C0.509603 9.1986 0.588491 9.38922 0.728942 9.52985L8.22894 17.0298C8.37112 17.1623 8.55916 17.2344 8.75346 17.231C8.94777 17.2276 9.13315 17.1489 9.27056 17.0115C9.40798 16.8741 9.48669 16.6887 9.49012 16.4944C9.49355 16.3001 9.42142 16.112 9.28894 15.9698L2.31894 8.99985L9.28894 2.02985C9.42142 1.88767 9.49355 1.69963 9.49012 1.50532C9.48669 1.31102 9.40798 1.12564 9.27056 0.988225C9.13315 0.850812 8.94777 0.7721 8.75346 0.768672C8.55916 0.765243 8.37112 0.837366 8.22894 0.969847L0.728942 8.46985Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.4ba73a43001f44988e3983399d0bc4f7.svg";
export { ForwardRef as ReactComponent };